import React, {useRef} from "react";
import {Modal} from "antd";

export default function ThreeDSecure({ threeDHtml, close3D, show3D }) {
    const iframeRef = useRef(null);

    return (
        <Modal
            title=""
            visible={show3D}
            onCancel={close3D}
            width="75%"
            footer={null}
            closable={true}
            bodyStyle={{ padding: 16, height: "80vh"}}
            maskClosable={false}
            style={{ maxWidth: "85vw",height: "80vh" }}
        >
            {show3D && (
                <iframe
                    key={threeDHtml}
                    ref={iframeRef}
                    title="3D Secure"
                    style={{ width: "100%", height: "100%", border: "none" }}
                    sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation allow-modals"
                    allow="payment *; otp-credentials *"
                    srcDoc={threeDHtml || ""}
                />
            )}
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/page/payment/topay/ThreeDSecure.js